import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export interface ArtikelMaschinentype {
    mtNr: number;
    artikelNr: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export const defaultArtikelMaschinentype: ArtikelMaschinentype = {
    mtNr: -1,
    artikelNr: '',
};

export interface ArtikelMaschinentypeFilter {
    artikelNr?: string;
    artikelNrList?: string[];
    mtNr?: number;
    maxRows?: number;
}

export async function getArtikelMaschinentypeList(filter: ArtikelMaschinentypeFilter): Promise<ArtikelMaschinentype[]> {
    return callApi<ArtikelMaschinentype[]>(Controller.artikelMaschinentype + '/list', {
        filter,
    });
}

export function useArtikelMaschinentype(
    filter: ArtikelMaschinentypeFilter,
    apiOptions?: UseApiOptions<ArtikelMaschinentype>,
): QueryResult<ArtikelMaschinentype> {
    return useApi<ArtikelMaschinentype>(Controller.artikelMaschinentype + '/one', { filter }, apiOptions);
}

export function useArtikelMaschinentypeList(
    filter: ArtikelMaschinentypeFilter,
    apiOptions?: UseApiOptions<ArtikelMaschinentype[]>,
): QueryResult<ArtikelMaschinentype[]> {
    return useApi<ArtikelMaschinentype[]>(Controller.artikelMaschinentype + '/list', { filter }, apiOptions);
}

export async function addArtikelMaschinentype(artikelMaschinentype: ArtikelMaschinentype): Promise<void> {
    return callApi<void>(Controller.artikelMaschinentype + '/add', { artikelMaschinentype });
}

export async function updateArtikelMaschinentype(artikelMaschinentype: ArtikelMaschinentype): Promise<void> {
    return callApi<void>(Controller.artikelMaschinentype + '/update', { artikelMaschinentype });
}
